import { render, staticRenderFns } from "./filter-data-modal-rec.vue?vue&type=template&id=50539d4a"
import script from "./filter-data-modal-rec.vue?vue&type=script&lang=js"
export * from "./filter-data-modal-rec.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports